import { removeTrapFocus, trapFocus } from '@/scripts/core/a11y';

function mobileNavInit() {
    const siteHtml = document.querySelector('[data-site-html]');
    const siteBody = document.querySelector('[data-site-body]');
    const siteContent = document.querySelector('[data-site-content]');
    const mobileNav = document.querySelector('[data-mobile-nav]');
    const mobileNavToggle = document.querySelector('[data-mobile-nav-toggle]');
    const mobileNavClose = document.querySelector('[data-mobile-nav-close]');
    const mobileNavBack = document.querySelector('[data-mobile-nav-back]');
    const mobileNavParentLinks = document.querySelectorAll('[data-mobile-nav-parent-link]');
    const mobileNavParentWrappers = document.querySelectorAll('[data-mobile-nav-parent-wrapper]');
    const mobileNavSearch = document.querySelector('[data-mobile-nav-search]');
    let scrollPosition = 0;

    if (!mobileNav) {
        return;
    }

    mobileNavParentLinks.forEach((mobileNavParentLink) => {
        mobileNavParentLink.addEventListener('click', () => {
            if (mobileNavParentLink.hasAttribute('href')) {
                return;
            }

            const parentLinkWrapper = mobileNavParentLink.closest('[data-mobile-nav-parent-wrapper]');

            mobileNavParentWrappers.forEach((mobileNavParentWrapper) => {
                mobileNavParentWrapper.classList.add('hide');
            });

            mobileNavSearch.classList.add('hide');
            parentLinkWrapper.classList.remove('hide');
            parentLinkWrapper.classList.add('active');
            mobileNavBack.classList.add('active');
        });
    });

    mobileNavBack.addEventListener('click', () => {
        mobileNavBack.classList.remove('active');
        mobileNavSearch.classList.remove('hide');

        mobileNavParentLinks.forEach((mobileNavParentLink) => {
            mobileNavParentLink.classList.remove('hide');
        });

        mobileNavParentWrappers.forEach((mobileNavParentWrapper) => {
            mobileNavParentWrapper.classList.remove('hide', 'active');
        });
    });

    mobileNavToggle.addEventListener('click', () => {
        scrollPosition = window.scrollY;

        if (window.scrollY >= 140) {
            siteHtml.classList.add('hide-header');
        }

        siteContent.style.marginTop = `-${scrollPosition}px`;
        siteHtml.classList.add('disable-scrolling');
        siteBody.classList.add('disable-scrolling');
        mobileNav.classList.remove('hide');
        trapFocus(mobileNav);
    });

    mobileNavClose.addEventListener('click', () => {
        mobileNav.classList.add('hide');
        siteHtml.classList.remove('disable-scrolling', 'hide-header');
        siteBody.classList.remove('disable-scrolling');
        siteContent.style.marginTop = '';
        window.scrollTo(0, scrollPosition);
        removeTrapFocus();
    });

    checkWindowSize();

    window.addEventListener('resize', () => {
        checkWindowSize();
    });

    function checkWindowSize() {
        if (window.innerHeight <= 553) {
            siteBody.classList.add('small-device');
        } else {
            siteBody.classList.remove('small-device');
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    mobileNavInit();
});
